export const PAYMENT_STATE = 'payment'

export const PAYMENT_LOGIN_GUEST = 'payment/PAYMENT_LOGIN_GUEST'

export const PAYMENT_TOKEN_VENMO = 'payment/PAYMENT_TOKEN_VENMO'
